export default __webpack_public_path__ + "static/media/stock-photo-bunch-of-red-grapes-removebg-preview.bb5161a7.png";